import React from "react";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import {INavButtonProps} from "../../element/button/IButton";
import {getManager} from "../../../ts/manager/Manager";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import AppButton from "../../element/button/AppButton";

const FooterStructure = () =>
{
    const socialChannelChoiceList:(INavButtonProps)[] = []
    const footerMenuChoiceList:RouteChoice[] = getModelFactory().browseRoute.getDefaultModel().choiceList().slice();
    const sitePagesChoiceList = (getModelFactory().subPageRoute.getDefaultModel("site_pages")?.choiceList() ?? []).slice();
    //const footerLegalsMenuChoiceList:(RouteChoice|INavButtonProps)[] = (sitePagesChoiceList as (RouteChoice|INavButtonProps)[] ).concat(getManager().ui.getUtilityNavChoiceList());
    const footerLegalsMenuChoiceList:(RouteChoice|INavButtonProps)[] = getManager().ui.getUtilityNavChoiceList();


    for(let i = 0; i < footerMenuChoiceList.length; i++){
        const choice = footerMenuChoiceList[i];

        if(["homepage", "my_profile", "archive", "unpublished", "pending", "site_pages"].includes(choice.id)){
            footerMenuChoiceList.splice(i, 1);
            i --;
        }
    }

    return <>
        <footer>
            <div className="container">

                {!!socialChannelChoiceList.length && <>

                    <div className="row d-flex align-items-start justify-content-center mb-5">
                        <div className="col text-center">
                            <ul className="horizontal-iconslarger">

                                {socialChannelChoiceList.map((choice, index) =>
                                {
                                    return <li key={index}>
                                        <AppButton
                                            {...choice}
                                            target="_blank"
                                        />
                                    </li>
                                })}

                            </ul>

                        </div>
                    </div>
                </>}

                <div className="row d-flex align-items-start">

                    <div className="col-3">
                        <nav aria-label="Footer">
                            <ul className="vertical-icons white mt-0">

                                {footerMenuChoiceList.map((choice, index) =>
                                {
                                    return <li key={index}>
                                        <RouteChoiceButton
                                            routeChoice={choice}
                                        />
                                    </li>
                                })}
                            </ul>
                        </nav>
                    </div>
                    <div className="col-3">
                        <nav aria-label="Footer">
                            <ul className="vertical-icons white mt-0">

                                {sitePagesChoiceList.map((choice, index) =>
                                {
                                    return <li key={index}>
                                        <RouteChoiceButton
                                            routeChoice={choice}
                                        />
                                    </li>
                                })}
                            </ul>
                        </nav>
                    </div>

                    <div className="col-3">

                        <nav aria-label="Footer">
                            <ul className="vertical-icons white  mt-0">

                                {footerLegalsMenuChoiceList.map((choice, index) =>
                                {
                                    return <li key={index}>
                                        {choice instanceof RouteChoice ?

                                            <RouteChoiceButton
                                                routeChoice={choice}
                                            /> :
                                            <AppButton
                                                {...choice}
                                            />
                                        }
                                    </li>
                                })}
                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
        </footer>
    </>;
}
export default FooterStructure;